import script from "./AlertForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertForm.vue?vue&type=script&setup=true&lang=js"

import "./AlertForm.vue?vue&type=style&index=0&id=08c6edab&lang=scss"

const __exports__ = script;

export default __exports__